module.exports = __webpack_public_path__ + "laliga_round-9a2010b616a839a897a339e645bbc79e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/no/laliga_round.png
// module id = 1183
// module chunks = 1 2